export function formatDuration(duration: string | number, includePrefix = false) {
    const newDuration = (typeof duration === 'string' ? parseInt(duration) : duration) || 0
    return `${!includePrefix ? '' : newDuration < 0 ? '-' : '+'}${Math.abs(newDuration) / 3600 < 10 ? '0' : ''}${Math.floor(Math.abs(newDuration) / 3600)}:${(Math.abs(newDuration) % 3600) / 60 < 10 ? '0' : ''}${Math.round((Math.abs(newDuration) % 3600) / 60)}`
}
